import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';

const Preloader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div 
      className="fixed inset-0 bg-brand-primary z-[100] flex items-center justify-center pointer-events-none transition-opacity duration-700 ease-out"
      aria-live="polite"
      aria-label="Carregando conteúdo"
    >
      <h1 className="text-4xl sm:text-5xl font-serif font-bold text-brand-light tracking-wide animate-pulse">
        {t('brandName') || 'DNA Musical'}
      </h1>
    </div>
  );
};

export default Preloader;
